import { useSelector } from "react-redux";
import VisualCategoryHeaderLinks from "./VisualCategoryHeaderLinks";
import visualLinksConfig from "../visualLinksConfig";
import { getCategoryId } from "../../../../../../../state/modules/category";
import useLocalisedChildLinks from "./useLocalisedChildLinks";

const ConnectedVisualCategoryHeaderLinks = props => {
  const childLinks = useLocalisedChildLinks(
    visualLinksConfig[useSelector(getCategoryId)]
  );

  return <VisualCategoryHeaderLinks {...props} childLinks={childLinks} />;
};

export default ConnectedVisualCategoryHeaderLinks;
